import ProgramsDashboard from "../../components/components/ProgramDashboard/index";


const Index = () => {
  return <ProgramsDashboard />;
};

export default Index;
